import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfListItemPaper from './lib/PubmedPdfPaper';
import PubmedPdfUtils, { type PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    journalId: number;
    year: number;
}

const PubmedPdfPapersByJournal = (props: Props) => {
    const { lang, journalId, year } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const journal = PubmedPdfUtils.getJournal(journalId);
    if (journal === null) {
        return <PageNotFound lang={lang} />;
    }
    const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
        {
            id: `j.${journal.id}`,
            name: Functions.mlang(journal.name, lang),
            link: PubmedPdfUtils.getJournalUrl(journalId, 0),
        },
    ];
    if (year !== 0) {
        breadcrumbs.push({ id: `y.${year}`, name: `${year}`, link: PubmedPdfUtils.getJournalUrl(journalId, year) });
    }
    const papers = PubmedPdfUtils.getPapersByJournalId(journalId, year);
    const years = PubmedPdfUtils.getYearsByPapers(papers);
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
            <hr />
            {year === 0 && (
                <>
                    <div className="years">
                        {years.map((year) => {
                            return (
                                <div className="year" key={year.year}>
                                    <Link to={PubmedPdfUtils.getJournalUrl(journalId, year.year)}>{year.year}</Link> (
                                    {year.count})
                                </div>
                            );
                        })}
                    </div>
                    <hr />
                </>
            )}
            <div className="papers">
                {papers.map((paper) => {
                    return <PubmedPdfListItemPaper key={paper.id} lang={lang} paper={paper} />;
                })}
            </div>
        </div>
    );
};

export default PubmedPdfPapersByJournal;
